module.exports = __webpack_public_path__ + "img/pills.8e673aee.svg";